<template>
  <div class="bto-sb-event-odds-content" ref="oddsContainer">
      <div class="bto-sb-event-odds" v-for="match in matches" :key="match.betRadarId">
          <MatchDetails
                  :match="match"
                  :showTeamIcon="showTeamIcon"
                  :show-odd-popup="showOddPopup"
                  :hide-odd-popup="hideOddPopup"
                  :get-popup-title="getPopupTitle"
                  :expanded-view="expandedView"
                  :has-live-stream="hasLiveStream"
                  :openLiveMatch="openLiveMatch">
          </MatchDetails>
          <div class="bto-sb-event-odds-right">
              <MatchInfo :match="match" :showStatistics="showStatistics" :showFavorite="showFavorite" />
              <div class="bto-sb-event-odds-cell">
                  <Fragment v-if="match.odds.hasOwnProperty(getFirstMid)">
                      <MatchOdd v-for="(outcome, oi) in match.odds[getFirstMid].outcomes"
                                :key="`oi${oi}`"
                                :is-three-way="isSportTreeWay"
                                :match="match"
                                :odd="match.odds[getFirstMid]"
                                :outcome="outcome"
                                :formatOutcome="formatOutcome"
                                :marketInf="markets[getFirstMid]"
                                :t="t"
                                :is-odd-selected="isOddSelected"
                                :expanded-view="expandedView"
                                :showTeamIcon="showTeamIcon"/>
                  </Fragment>
                  <Fragment v-else>
                    <span class="bto-sb-event-odd">
                      <logo-component v-if="showTeamIcon" v-slot="{ url, reset, onLoad, loaded }" :logo-url="match.homeTeamIcon">
                        <span class="bto-sb-event-team-logo bto-sb-event-hometeam-logo" v-if="url" v-show="loaded">
                          <img :src="url" alt="" @error="reset" @load="onLoad" />
                        </span>
                      </logo-component>
                      <i>{{match.homeTeam}}</i>
                      <i>--</i>
                    </span>
                     <span class="bto-sb-event-odd bto-sb-event-odd-x" v-if="isSportTreeWay">
                      <i>{{t('Mobile.outcomexname')}}</i>
                      <i>--</i>
                    </span>
                    <span class="bto-sb-event-odd">
                      <logo-component v-if="showTeamIcon" v-slot="{ url, reset, onLoad, loaded }" :logo-url="match.guestTeamIcon">
                        <span class="bto-sb-event-team-logo bto-sb-event-awayteam-logo" v-if="url" v-show="loaded">
                          <img :src="url" alt="" @error="reset" @load="onLoad" />
                        </span>
                      </logo-component>
                      <i>{{match.guestTeam}}</i>
                      <i>--</i>
                    </span>
                  </Fragment>
              </div>
              <MoreOdds :match="match" :cashOutVisibility="cashOutVisibility" :showMarketsInMatch="showMarketsInMatch"></MoreOdds>
          </div>
      </div>
  </div>
</template>

<script>
  import LiveDefault from './live-default';

  export default {
    name: "LiveExpanded",
    extends: LiveDefault
  };
</script>

<style scoped>
</style>
